<script>
    import { EventEmitterInstance } from '@src/utils/event-emitter';
    import {
        gameState,
        videoUrl,
        gameResult,
        currency,
        gameRoundInfo,
        allowToBet,
        multipliers,
        selectedBetAmount
    } from '@src/store/index';
    import { abTestParams, currencyDecimal } from './store/misc';
    import { availableChips, selectedChipIndex, showBetSizeChips, chipPrice } from './store/chips';
    import { gameStates } from '@root/src/states/machine/state-types';
    // components
    import VideoPlayer from '@src/components/ui/video/video-player.svelte';
    import UiScreen from '@src/components/ui/ui-screen.svelte';
    import GameScreen from '@src/components/ui/game-screen.svelte';
    import TransitionBonusGame from '@src/components/ui/animations/transition-bonus-game.svelte';
    import { showBonusGameTransition, showTopSlot, showWelcomeScreens } from './store/ui';
    import BetsContainer from './components/ui/bets/bets-container.svelte';
    import GameResults from './components/ui/game-results/game-results.svelte';
    import Backdrop from './components/ui/backdrop.svelte';
    import CircleChipsContainer from './components/ui/chips/circle-chips-container.svelte';
    import TopSlot from './components/ui/animations/top-slot.svelte';
    import WheelOfFortune from './components/ui/animations/wheel-of-fortune.svelte';
    import TopControls from './components/ui/top-controls.svelte';
    import CashReels from './components/ui/animations/cash-reels.svelte';
    import BallSpin from './components/ui/animations/ball-spin.svelte';
</script>

<div
    class="wrapper-central relative h-full bg-gradient-to-b from-game-backdrop to-black s-phone:!max-h-screen s-phone:!max-w-[60.515vh]"
>
    {#if $gameRoundInfo?.resp?.top_slot && $showTopSlot && !$showWelcomeScreens}
        <TopSlot
            multipliersLeft={$gameRoundInfo?.resp?.top_slot?.multipliers}
            selectedLeftMultiplier={$gameRoundInfo?.resp?.top_slot?.multiplier}
            multiplierRight={$gameRoundInfo?.resp?.top_slot?.types}
            selectedRightMultiplier={$gameRoundInfo?.resp?.top_slot?.type}
        />
    {/if}

    <VideoPlayer
        src={$videoUrl}
        videoType={$abTestParams?.video}
        on:initSource={() => {}}
        on:playing={() => {
            $showTopSlot = true;
        }}
        on:ended={() => {
            EventEmitterInstance.emit('round-video-finish');
        }}
        on:lowPowerMode={() => {}}
    />

    {#if $gameState === gameStates.game && $allowToBet}
        <BetsContainer />
    {/if}

    {#if $gameState === gameStates.plinko && $showBonusGameTransition === false}
        <GameScreen>
            <square-plinko multipliers={$multipliers} class="mt-[40px] w-[400px]" />
        </GameScreen>
    {/if}

    {#if $gameState === gameStates.bigWin}
        <Backdrop />
        <GameResults gameResult={$gameResult} currency={$currency} />
    {/if}
    <slot />
    <UiScreen>
        {#if ($gameState === gameStates.plinko || $gameState === gameStates.wheelOfFortune || $gameState === gameStates.cashReels || $gameState === gameStates.ballSpin) && $showBonusGameTransition && !$showWelcomeScreens}
            <TransitionBonusGame
                bonusGameType={$gameState}
                on:end={() => {
                    EventEmitterInstance.emit('bonus-transition-finish');
                }}
            />
        {/if}

        {#if $gameState === gameStates.ballSpin && $showBonusGameTransition === false}
            <BallSpin
                arrMultipliersLeft={$gameRoundInfo?.resp?.ball_spin_params?.left_multipliers}
                arrMultipliersRight={$gameRoundInfo?.resp?.ball_spin_params?.right_multipliers}
            />
        {/if}

        {#if $gameState === gameStates.cashReels && $showBonusGameTransition === false}
            <CashReels
                multipliersLeft={$gameRoundInfo?.resp?.cash_reels_params?.reels[0]}
                multipliersMiddle={$gameRoundInfo?.resp?.cash_reels_params?.reels[1]}
                multipliersRight={$gameRoundInfo?.resp?.cash_reels_params?.reels[2]}
                prevMultipliers={$gameRoundInfo?.resp?.cash_reels_params?.prev_multipliers}
            />
        {/if}

        {#if $gameState === gameStates.wheelOfFortune && $showBonusGameTransition === false}
            <WheelOfFortune sectorMultipliers={$gameRoundInfo?.resp?.fortune_wheel_params?.sectors} />
            <!-- <div class="absolute left-0 top-5 bg-white">
                State {$gameState}<br /> isFinal {$gameRoundInfo?.final} <br />
                {JSON.stringify($gameRoundInfo?.resp?.fortune_wheel_params)} <br />
                Result: {JSON.stringify($gameRoundInfo?.resp?.fortune_wheel_result)}
            </div> -->
        {/if}
    </UiScreen>

    {#if $showBetSizeChips}
        <CircleChipsContainer
            items={$availableChips}
            selectedChipIndex={$selectedChipIndex}
            selectedChipAmount={$availableChips[$selectedChipIndex]}
            currency={$currency}
            chipPrice={$chipPrice}
            decimal={$currencyDecimal}
            selectedValue={$selectedBetAmount}
            on:select-chip-size={event => {
                $selectedChipIndex = event.detail;
                $showBetSizeChips = false;
            }}
        />
    {/if}
    <TopControls />
</div>
